import { IViewModifierContext } from './viewModifierContext';

export enum ViewModifierActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	REFETCH_PORTIONS_DATA = 'REFETCH_PORTIONS_DATA',
	SET_MODIFIER_FULL_INFO = 'SET_MODIFIER_FULL_INFO',
	SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS = 'SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS',
	SET_RESTAURANT_PROPS = 'SET_RESTAURANT_PROPS',
	SET_RESTAURANT_ID_FOR_PORTIONS = 'SET_RESTAURANT_ID_FOR_PORTIONS',
	SET_RESTAURANT_PORTIONS = 'SET_RESTAURANT_PORTIONS',
	CHANGE_SELECTED_PORTION_ID = 'CHANGE_SELECTED_PORTION_ID',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: ViewModifierActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IViewModifierContext['needRefetchData'];
	};
}

interface IRefetchRestPropsData {
	type: ViewModifierActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IViewModifierContext['needRefetchRestPropsData'];
	};
}

interface IRefetchPortionsData {
	type: ViewModifierActionTypes.REFETCH_PORTIONS_DATA;
	payload: {
		needRefetchRestaurantPortionsData: IViewModifierContext['needRefetchRestaurantPortionsData'];
	};
}

interface ISetModifierFullInfo {
	type: ViewModifierActionTypes.SET_MODIFIER_FULL_INFO;
	payload: {
		modifierFullInfo: IViewModifierContext['modifierFullInfo'];
		accessibleRestaurants: IViewModifierContext['accessibleRestaurants'];
		accessiblePortionsRestaurants: IViewModifierContext['accessiblePortionsRestaurants'];
	};
}

interface ISetRestaurantIdForRestaurantProps {
	type: ViewModifierActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS;
	payload: {
		restaurantIdForRestaurantProps: IViewModifierContext['restaurantIdForRestaurantProps'];
		restaurantProps: IViewModifierContext['restaurantProps'];
	};
}

interface ISetRestaurantProps {
	type: ViewModifierActionTypes.SET_RESTAURANT_PROPS;
	payload: {
		restaurantProps: IViewModifierContext['restaurantProps'];
	};
}

interface ISetRestaurantIdForPortions {
	type: ViewModifierActionTypes.SET_RESTAURANT_ID_FOR_PORTIONS;
	payload: {
		restaurantIdForPortions: IViewModifierContext['restaurantIdForPortions'];
		restaurantPortions: IViewModifierContext['restaurantPortions'];
	};
}

interface ISetRestaurantPortions {
	type: ViewModifierActionTypes.SET_RESTAURANT_PORTIONS;
	payload: {
		restaurantPortions: IViewModifierContext['restaurantPortions'];
	};
}

interface IChangeSelectedPortionId {
	type: ViewModifierActionTypes.CHANGE_SELECTED_PORTION_ID;
	payload: {
		selectedPortionId: IViewModifierContext['selectedPortionId'];
	};
}

interface ISetTranslationTab {
	type: ViewModifierActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewModifierContext['selectedTranslationTab'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ViewModifierActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IViewModifierContext['typeOfModalWindow'];
	};
}

export type TViewModifierAction =
	| IRefetchData
	| IRefetchRestPropsData
	| IRefetchPortionsData
	| ISetModifierFullInfo
	| ISetRestaurantIdForRestaurantProps
	| ISetRestaurantProps
	| ISetRestaurantIdForPortions
	| ISetRestaurantPortions
	| IChangeSelectedPortionId
	| ISetTranslationTab
	| IChangeTypeOfModalWindow;
